<template>
    <div class="weekMonthBlock-wrap">
        <!--<div class="weekMonthBlock-title">
            Год/Месяц/Неделя
        </div>-->
        <day></day>
        <week></week>
        <month></month>
        <year></year>
    </div>
</template>
<script>
import WeekWidget from './week-stat-widget.vue'
import MonthWidget from './month-stat-widget.vue'
import YearWidget from './year-stat-widget.vue'
import DayWidget from './day-stat-widget'
export default {
   components: {
       'week':WeekWidget,
       'month':MonthWidget,
       'year':YearWidget,
       'day':DayWidget
   }

}
</script>
<style lang="less" scoped>
.weekMonthBlock {
    &-wrap {
        background: #324258;
        border-radius: 8px;
    }
    &-title {
        font-family: Montserrat;
        font-size: 16px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: 3;
        letter-spacing: 0.4px;
        color: #fff;
        margin-left: 16px;
    }
}
</style>